export async function decompressGzipBase64(base64String: string): Promise<string> {
  let compressed = Uint8Array.from(atob(base64String), c => c.charCodeAt(0));
  let stream = new DecompressionStream('gzip');
  let decompressed = await new Response(
    new Blob([compressed]).stream().pipeThrough(stream)
  ).text();
  return decompressed;
}
